<template>
  <div>
    <div class="return" v-if="type != 'order'" @click="back">
      <img class="backImg" src="@/assets/images/back.png" alt />
    </div>
    <div class="conMsg">
      <div class="top">
        <div class="title">
          <i class="el-icon-collection-tag" />基本资料
        </div>
        <div style="text-align: right;">
          <el-button  v-if="detail.status != 3 && detail.referral_order_id<1" type="danger" size="mini" class="mb10" plain @click="openDialog('修改订单')">修改订单</el-button>
          <el-button  v-if="detail.status != 4 && detail.referral_order_id<1" type="danger" size="mini" class="mb10" plain @click="hint('del','作废此订单')">作废订单</el-button>
        </div>
      </div>
      <el-descriptions class="margin-top" :column="3" border>
        <el-descriptions-item>
          <template slot="label">销售部门</template>
          {{detail.shop_name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">客户姓名</template>
          {{detail.consignee}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">护理师</template>
          {{detail.sale_name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">业务类型-业务二级分类</template>
          {{detail.business_type}}-
          {{detail.business_two_type_text?detail.business_two_type_text:'暂无'}}
        </el-descriptions-item>
        <!-- <el-descriptions-item>
          <template slot="label">业务二级分类</template>
          {{detail.business_two_type_text}}
        </el-descriptions-item> -->
        <el-descriptions-item>
          <template slot="label">项目类型</template>
          {{detail.project_type_name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">订单类型</template>
          {{detail.order_type}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">销售组织</template>
          {{detail.sales_name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">发货组织</template>
          {{detail.settlement_name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">发货部门</template>
          {{detail.delivery_name}}
        </el-descriptions-item>
        <!-- <el-descriptions-item>
          <template slot="label">发货仓库</template>
          {{detail.house_code_name}}
        </el-descriptions-item> -->
        <el-descriptions-item>
          <template slot="label">市场</template>
          {{detail.market_name?detail.market_name:'暂无'}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">录单员</template>
          {{detail.operator_name?detail.operator_name:'暂无'}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">金蝶单号</template>
          {{detail.king_sale_no?detail.king_sale_no:'暂无'}}
        </el-descriptions-item>
         <!-- <el-descriptions-item>
          <template slot="label">是否体验</template>
          {{detail.is_experience==0?'否':'是'}}
        </el-descriptions-item> -->
        <!-- <el-descriptions-item>
          <template slot="label">是否外联</template>
          {{detail.is_outreach==0?'否':'是'}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label" >外联人</template>
          {{detail.outreahc_name?detail.outreahc_name:'无'}}
        </el-descriptions-item> -->
        <!-- <el-descriptions-item>
          <template slot="label">是否转介绍</template>
          {{detail.is_introduction==0?'否':'是'}}
        </el-descriptions-item>
        <el-descriptions-item >
          <template slot="label">转介绍人</template>
          {{detail.introduction_name?detail.introduction_name:'无'}}
        </el-descriptions-item> -->
        <el-descriptions-item>
          <template slot="label">创建时间</template>
          {{detail.create_time}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">销售合计</template>
          {{detail.total_amount}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">优惠券抵扣</template>
          {{detail.discount_amount}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">实收金额</template>
          {{detail.pay_amount}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">赠送金额</template>
          {{detail.gift_amount}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">店转金额</template>
          {{detail.shop_transfer_amount}}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">订单状态</template>
          {{detail.status_msg}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">支付时间</template>
          {{detail.pay_time?detail.pay_time:'暂无'}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">成交时间</template>
          {{detail.deal_time?detail.deal_time:'暂无'}}
        </el-descriptions-item>
        <el-descriptions-item >
          <template slot="label">取消时间</template>
          {{detail.cancel_time?detail.cancel_time:'暂无'}}
        </el-descriptions-item>
		<el-descriptions-item >
		  <template slot="label">收入类型</template>
		  <span v-if="detail.income_type == 1">服务（各类疗程卡项及疗程卡项赠送产品）</span>
		  <span v-if="detail.income_type == 2">产品销售（单独付费购买产品）</span>
		  <span v-if="detail.income_type == 3">医美收入</span>
		</el-descriptions-item>
    <el-descriptions-item >
            <template slot="label">备注</template>
            {{detail.description?detail.description:'暂无'}}
          </el-descriptions-item>
        </el-descriptions>
      </el-descriptions>

    </div>
    <div class="conMsg">
      <div class="top">
        <div class="title">
          <i class="el-icon-collection-tag" />商品列表
        </div>
        <div style="text-align: right;">
          <el-button  v-if="detail.status != 3 && detail.referral_order_id<1" type="danger" size="mini" class="mb10" plain @click="refundGoodsOneAll(detail.id)">一键全退</el-button>
          <el-button  v-if="detail.status != 4 && detail.referral_order_id<1" type="info" size="mini" class="mb10" plain @click="refundGoodsOneList(detail.id)">单品退列表</el-button>
        </div>
      </div>

      <div class="table">
        <!--列表-->
        <el-table
          :data="goodsList"
          size="small"
          border
          default-expand-all
          :row-style="setRowStyle"
          :cell-style="$style.cellStyle"
          :header-cell-style="$style.rowClass"
        >
          <el-table-column type="expand" width="50" >
            <template slot-scope="props" >
              <div v-if="props.row.product_children && props.row.goods_type == 1">
                <el-table   :data="props.row.product_children" :fit="true" :row-key="(row) => row.id" :show-header="false"   border  class="table_body"  >
                  <el-table-column width="50"  />
                  <el-table-column width="330" prop="name"  align="center"  />
                  <el-table-column width="170" prop="business_type"  align="center"  />
                  <el-table-column width="160" prop="business_type"  align="center"  />
                  <el-table-column width="160" prop="number" align="center"  />
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" prop="goods_name" />
          <el-table-column label="商品名称-别名" prop="goods_alias_name" />
          <ElTableColumn label="服务/商品" prop="type">
          </ElTableColumn>
          <el-table-column label="业务类型" prop="data_business_type" />
          <el-table-column label="业务二级类型" prop="data_business_two_type" />
          <el-table-column label="标准单价" prop="goods_price" />
          <el-table-column label="数量" prop="number" />
          <el-table-column label="销售单价" prop="pay_price" />
          <el-table-column label="销售金额" prop="order_goods_price" />
          <ElTableColumn label="优惠后本金">
                 <template slot-scope="{ row }">
                <span >{{row.pay_amount  || '-'}}</span>
              </template>
            </ElTableColumn>
                 <ElTableColumn label="优惠后赠金">
                 <template slot-scope="{ row }">
                <span >{{row.gift_amount  || '-'}}</span>
              </template>
            </ElTableColumn>
                 <ElTableColumn label="优惠后店转">
                 <template slot-scope="{ row }">
                <span >{{row.shop_transfer_amount  || '-'}}</span>
              </template>
            </ElTableColumn>
          <el-table-column label="商品/服务类型">
            <template slot-scope="{ row }">
              <div v-if="row.goods_type != 2 && row.project_type == 1 ">按次</div>
              <div v-else-if="row.goods_type != 2 &&row.project_type == 2">按天</div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column label="服务">  
            <template slot-scope="{ row }">
              <div v-if="row.goods_type != 2 && row.project_type == 1 ">{{row.service_number}}次</div>
              <div v-else-if="row.goods_type != 2 &&row.project_type == 2 ">{{row.start_time}}-{{row.end_time}}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column label="预存货选项" prop="prestock_type" />
          <el-table-column label="存/出货数量" prop="takeout_stock_num" />

          <ElTableColumn label="操作">
            <template slot-scope="{ row }">
              <el-button type="danger" size="mini" class="mb10"  plain @click="openRefundDialog(row)">退货</el-button>
            </template>
          </ElTableColumn>

          <!-- <el-table-column label="陪护师一"  prop="nurse_one_name"> </el-table-column>
          <el-table-column label="陪护师一服务小项"  prop="nurse_one_project_text"> </el-table-column>
          <el-table-column label="陪护师二"  prop="nurse_two_name"> </el-table-column>
          <el-table-column label="陪护师二服务小项"  prop="nurse_two_project_text"> </el-table-column> -->

        </el-table>
         <div class="total">
          <span>订单总额：</span>
          <span class="peril">{{this.detail.total_amount}}</span>
        </div>
      </div>
    </div>

    <div class="conMsg">
      <!-- <div class="top">
        <div class="title">
          <i class="el-icon-collection-tag" />陪护师及服务小项变更记录
        </div>
      </div> -->
      <!-- <div class="table">
      
        <el-table
          :data="orderGoodsOption"
          size="small"
          border
          :cell-style="$style.cellStyle"
          :header-cell-style="$style.rowClass"
        >

          <ElTableColumn label="商品名称">
            <template slot-scope="{ row }">
              {{row.goods_name}}
              <span v-if="row.is_new == 1" style="color: red;">(新)</span>
            </template>
          </ElTableColumn>
          <el-table-column label="陪护师一"  prop="nurse_one_name"> </el-table-column>
          <el-table-column label="陪护师一服务小项"  prop="nurse_one_project_text"> </el-table-column>
          <el-table-column label="陪护师二"  prop="nurse_two_name"> </el-table-column>
          <el-table-column label="陪护师二服务小项"  prop="nurse_two_project_text"> </el-table-column>
          <el-table-column label="操作时间"  prop="create_time"> </el-table-column>
        </el-table>

      </div> -->
    </div>

    <el-dialog
      title="退货商品列表"
      :visible.sync="refundPopup"
      :close-on-click-modal="false"
      width="1200px"
      @close="closeRefundTicket"
    >
      <div>
        <el-row type="flex" justify="space-between" class="mt20">
          <el-col :span="24">
            <el-table
              :data="orderMinList"
              row-key="id"
              ref="serviceTable"
              size="small"
              border
              @selection-change="handleSelectionChange"
              :cell-style="$style.cellStyle"
              :header-cell-style="$style.rowClass"
            >
            <el-table-column
              type="selection"
              width="55"
              >
            </el-table-column>
            <!-- <ElTableColumn label="选项" prop="goods_name" fixed width="160" >
              <template slot-scope="{ row }">
                  <el-checkbox v-model="row.checked"></el-checkbox>
                </template>
            </ElTableColumn> -->
              <el-table-column label="商品名称" prop="goods_name" />
              <el-table-column label="*退货数量" width="160" >
                <template scope="{row}">
                  <el-input-number
                    v-model="row.refund_num"
                    :precision="2"
                    :min = "0.01"
                    :max = "Number(row.number)"
                    :step = "0.01"
                    size="mini"
                    @change="(value) => handleChange(value , '' ,'prestock')"
                    v-if="row.goods_type == 2"
                  />
                  <div v-else>{{row.number}}</div>
                </template>
              </el-table-column>
              <el-table-column label="商品类型" prop="goods_type" >
                <template scope="{row}">
                  {{row.goods_type == 2 ? '商品' : row.goods_type == 3 ? '服务' : '品项'}}
                </template>
              </el-table-column>
              <el-table-column label="卡项类型">
                <template scope="{row}">
                  <div v-if="row.goods_type == 2">--</div>
                  <div v-if="row.goods_type != 2 && row.project_type == 1">按次</div>
                  <div v-if="row.goods_type == 1 && row.project_type == 2">按天</div>
                </template>
              </el-table-column>
              <el-table-column label="天数或次数">
                <template scope="{row}">
                  <div v-if="row.goods_type != 1">--</div>
                  <div v-if="row.goods_type == 1 && row.project_type == 1">{{row.service_number}}次</div>
                  <div v-if="row.goods_type == 1 && row.project_type == 2">{{row.service_day}}天</div>
                </template>
              </el-table-column>
              <el-table-column label="*退货次数" width="160">
                <template scope="{row}">
                  <el-input-number
                    v-model="row.refund_service_num"
                    :precision="2"
                    :min = "1"
                    :max = "parseInt(row.service_number)"
                    :step = "1"
                    size="mini"
                    @change="(value) => handleChange(value , '' ,'prestock')"
                    v-if="row.project_type == 1 && row.goods_type == 1"
                  />
                  <div v-else>--</div>
                </template>
              </el-table-column>
            </el-table>
            <div class="flexSb mt20">
              <div></div>
            </div>
          </el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="repayCardConfirm()">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { orderDetail, orderGoodsDetail, checkOrder, orderGoodsOptionDetail,refundItemOne ,refundItemOneAll} from "@/api/order";
export default {
  data() {
    return {
      detail: {},
      goodsList: [],
      orderGoodsOption: [],
      orderGoodsDetail: [],
      type: 'order',
      refundPopup: false,
      orderMinList: [],
      selectList: [] // 选中列表
    };
  },
  mounted() {
    this.getDetail();
    this.type = this.$route.query.type;
  },
  methods: {
    setRowStyle({ row }) {
      return row.goods_type === 1
        ? { '--expand-color': 'black' }
        : { '--expand-color': 'white' };
    },
    openRefundDialog(row) {
      this.refundPopup = true;
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    // 获取详情
    getDetail() {
      orderDetail({ order_id: this.$route.query.id }).then(res => {
        this.detail = res;
      });
      
      
      orderGoodsDetail({ order_id: this.$route.query.id }).then(res => {
        this.goodsList = res.goodsList;
        
        this.orderMinList = res.goodsList.map(item => ({
          id: item.id, 
          order_goods_id:item.order_goods_id,                          
          goods_name: item.goods_name,           
          number: item.number,                    
          service_number: item.service_number,    
          goods_type: item.goods_type,
          project_type: item.project_type,       
          
          refund_num: Number(item.number) || 0,
          refund_service_num: Number(item.service_number) || 0,
          
          checked: false
        }));
      });
      
      orderGoodsOptionDetail({ order_id: this.$route.query.id }).then(res => {
        this.orderGoodsOption = res.list;
      });
    },
    // 提示
    hint(type, text) {
      this.$confirm(`${text}，是否确定？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (type == 'del') {
          this.delOrder();
        }
      }).catch(() => {
        this.$message.info("已取消");
      });
    },
    delOrder() {
      checkOrder({ order_id: this.$route.query.id, status: 4 }).then(res => {
        this.$message.success(res.msg);
        this.type != 'order' ? this.back() : this.$router.go(-1);
      });
    },
    openDialog(type) {
      const query = {
        detail: this.detail,
        clienId: this.$route.query.clienId
      };
      if (type === "修改订单") {
        this.$router.push({ name: "修改销售订单", query });
      }
    },
    back() {
      const query = {
        detail: this.$route.query.detail,
        id: this.$route.query.clienId,
        activeName: 'second1',
        activeTab: 'salesRecords'
      };
      this.$router.push({ name: '客户详情', query });
    },
    closeRefundTicket() {
      this.$refs.serviceTable.clearSelection();
      this.selectList = [];
    },
    repayCardConfirm() {
      if (this.selectList.length === 0) {
        this.$message.warning('请选择要退货的商品');
        return;
      }
      
      console.log('选中退货项：', this.selectList);
      refundItemOne({
        uid:this.$route.query.clienId,
        order_id: this.$route.query.id,
        goods_list: this.selectList
      }).then(res => {
        this.$message.success('退货操作成功');
        this.refundPopup = false;
      });
    },
    refundGoodsOneList(order_id){
      const query = {
        order_id: order_id,
      };
      this.$router.push({ name: '单品退列表', query });
    },
    refundGoodsOneAll(order_id){
      refundItemOneAll({
        uid:this.$route.query.clienId,
        order_id: this.$route.query.id,
     
      }).then(res => {
        this.$message.success('退货操作成功');
        this.refundPopup = false;
      });
      
    }


  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-table__expand-icon {
  color: var(--expand-color, #909399) !important;
}
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}
::v-deep .el-table__body-wrapper {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.conMsg {
  margin-bottom: 30px;
  .top {
    display: flex;
    justify-content: space-between;
    .title {
      font-weight: bold;
      font-size: 14px;
      line-height: 34px;
      color: #666;
    }
  }
  .table {
    border-top: 1px solid #eee;
    .total {
      text-align: right;
      padding: 10px 64px 10px 80px;
      box-sizing: border-box;
      background: #f9fafc;
      border: 1px solid #eee;
      border-top: 0;
      span {
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
}
::v-deep .el-descriptions-item__label.is-bordered-label{
  background: #f9fafc;
}
.return {
  position: fixed;
  right: 20px;
  top: 71px;
  z-index: 999;
  .backImg {
    margin-right: 14px;
    width: 32px;
    height: 100%;
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>